import { conceptType } from '../variables/Enums';
import axios from './index';

export const searchConcept = (conceptId, term, type = conceptType.events) => {
    return axios.get(`api/v1/snowstorm/${type}/SearchConcept/${conceptId}/${term}`);
};

export const searchConceptByExpression = (expression, term, type = conceptType.events) => {
    return axios.get(`api/v1/snowstorm/${type}/SearchByExpression/${expression}/${term}`);
};

export const searchFrequentConcepts = (type = conceptType.events, term, take) => {
    return axios.get(`api/v1/concept/frequent?conceptType=${type}&term=${encodeURIComponent(term)}&take=${take}`);
};

export const getConceptUsages = (term, pageSize, pageIndex) => {
    const query = new URLSearchParams();
    if (term) query.append('term', term);
    query.append('pageSize', pageSize);
    query.append('pageIndex', pageIndex);

    return axios.get(`api/v1/concept/usages?${query.toString()}`);
};

export const setConceptUsage = (conceptId, usageCount) => {
    return axios.put(`api/v1/concept/${conceptId}/usage`, { usageCount });
};